import actions from './token.actions'

export default {
  namespaced: true,
  actions
}
